<template>
  <v-chip-group column>
    <v-chip
      v-for="value in shownValues" :key="value"
      label
      outlined
      exact
      :to="{name: 'Films', query: {[query]: value}}"
    >
      {{ value }}
    </v-chip>
    <v-chip
      v-if="chipsLeft"
      label
      outlined
      disabled
    >
      +{{ chipsLeft }} more
    </v-chip>
  </v-chip-group>
</template>

<script>
export default {
  name: 'ChipGroup',
  props: {
    values: Array,
    query: String,
    maxShown: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    shownValues() {
      if (this.maxShown && this.values.length > this.maxShown) {
        return this.values.slice(0, this.maxShown - 1);
      }
      return this.values
    },
    chipsLeft() {
      return this.values.length - this.shownValues.length
    }
  }
}
</script>
